export default "__VITE_ASSET__DbmN4o6A__"